<template>
	<div class="type-talk" :class="className">
		<div class="chat-hide" :class="unreadLength ? 'unread-message' : ''" :data-number="unreadLength" @click="toggleDisplay(true)" v-show="isHidden">
			<img class="chat-logo" :src="chatPhoto" alt="">
		</div>
		<div class="chat-show" v-show="isDisplay">
			<div class="chat-header">
				<transition name="fade-text">
					<div class="message-text" v-show="showType === 'input'">Type your questions...</div>
				</transition>
				<transition name="fade-text">
					<div class="loading-text" v-show="showType === 'await'">Typing......</div>
				</transition>
				<span class="chat-close" @click="toggleDisplay(false)"></span>
			</div>
			<div class="chat-content">
				<div class="chat-list" ref="scroll-content">
					<div class="single-chat" :class="items.type === 'customer' ? 'self-chat' : 'side-chat'" :key="index" v-for="(items, index) in chatList">
						<div class="chat-view">
							<img class="chat-img" :src="items.type === 'customer' ? userPhoto : chatPhoto" alt="">
							<div class="chat-info">
								<div class="name-time">
									<span class="chat-name" v-text="items.type === 'customer' ? 'Me' : 'Service'"></span>
									<span class="chat-time">{{items.time | timeParse}}</span>
								</div>
								<div class="text-view" v-html="textParse(items)"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="chat-footer">
				<textarea class="chat-text" v-model="chatText" placeholder="Please enter your questions..." @focus="toggleContact"></textarea>
				<div class="button-view">
					<button class="chat-button" @click="sendText">Send</button>
					<button class="chat-button" style="margin-top: 10px;" @click="clearText">Clear</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '../mixin.js'
	import socket from 'util/socket.js'
	import prepareAnswer from './prepareAnswer.js'
	import markdownMiniParser from './markdownMiniParser.js'

	export default {
		name: 'type-talk',
		props: {
			chatVid: {
				type: String,
				default: ''
			}
		},
		mixins: [ mixin ],
		data() {
			return {
				isHidden: false,
				chatText: '',
				showType: '',
				chatList: [],
				adminUUID: '',//'456',
				chatSocket: null,
				unreadLength: 0,
				uuid: '' // Add uuid to your data
			}
		},
		created() {
			this.uuid = this.getUUID();
			this.getChatList();
		},
		methods: {
			// Method to get the UUID from localStorage or generate a new one
			getUUID() {
				let uuid = localStorage.getItem('uuid');
				if (!uuid) {
					uuid = this.generateUUID();
					localStorage.setItem('uuid', uuid);
				}
				return uuid;
			},
			// Method to generate a UUID
			generateUUID() {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					const r = (window.crypto && window.crypto.getRandomValues)
						? crypto.getRandomValues(new Uint8Array(1))[0] % 16
						: Math.random() * 16;
					const v = c === 'x' ? r : (r & 0x3 | 0x8);
					return v.toString(16);
				});
			},
			async sendText() {
        		if (!this.$userInfo.data.name) {
        			this.toggleContact();
        			return false;
        		}
				if (this.chatText === '') {
					this.showTipMsg('input', 2600);
					return;
				}
				const chatText = this.chatText;
				const vid = this.chatVid;// || 'MSF9234';
				const apiData = {
					url: window.location.href,
					action: '/chat/message',
					chatTarget: vid,//'456',//this.adminUUID,//this.adminUUID,
					deviceUUID: this.uuid,
					vid: this.chatVid
				};
				console.log(apiData);
				//this.chatText = '';
				this.addNewMessage({ type: 'customer', text: chatText });
				// 发送聊天内容到客服端
				this.socketLogin();
				this.chatSocket.emit('communication', {
					...apiData,
					data: {
						senderName: this.name,
						text: chatText,
						time: this.getNowTime(),
						type: 'customer'
					}
				});
				
				let answerResult = this.findPrepareAnswer(chatText);
				// 本地预制回答
				if (answerResult) {
					await this.timeout(1000);
				}
				// AI接口回答
				else {
					this.showTipMsg('await', 60000);
					const { status, data } = await this.$http.ai.query({ vid, input_text: chatText, access_token: this.$config.ACCESS_TOKEN,server_location:this.$config.region});
					this.showTipMsg('');
					if (status !== 'success') {
						return;
					}
					answerResult = data.rewritten_text;
				}
				this.addNewMessage({ type: 'chat_intelligence', text: answerResult });
				// 将本地预制回答orAI接口回答发送聊天内容到客服端
				this.socketLogin();
				this.chatSocket.emit('communication', {
					...apiData,
					data: {
						senderName: this.name,
						text: answerResult,
						time: this.getNowTime(),
						type: 'chat_intelligence'
					}
				});
			},
			timeout(duration = 500) {
				return new Promise(resolve => {
					const timer = setTimeout(() => {
						clearTimeout(timer);
						resolve(duration);
					}, duration);
				});
			},
			clearText() {
				this.chatText = '';
			},
			textParse(item) {
				const { type, text } = item;
				const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
				if (type === 'chat_intelligence') {
					return markdownMiniParser(text);
					// return marked.parse(text);
				}
				return text.replace(urlRegex, function(url) {
					// 如果是图片链接为图片标签
					if (/\.(jpeg|jpg|gif|png|svg)$/i.test(url)) {
						return `<img src="${url}" alt="image" style="font-size: 0;max-width: 100%;line-height: 0;vertical-align: top;" />`;
					}
					// 替换为超链接标签
					return `<a href="${url}" target="_blank">${url}</a>`;
				});
			},
			getNowTime() {
				return Date.parse(new Date()) / 1000;
			},
			showTipMsg(type, duration) {
				// input await
				this.showType = type;
				duration && this.timeout(duration).then(() => this.showType = '');
			},
			getChatList() {
			  // console.clear()
			  const token = this.uuid;
			  this.$http.custom.getChatMessagesList(this.api.getChatMessagesList, { token }).then(res => {
			    const prepare = this.chatHandler({ type: 'chat_intelligence', text: 'At your service' });
			    if (res.code === 0 && res.data && res.data.length) {
			      this.chatList = res.data.map(item => this.chatHandler(item));
			      this.chatList.unshift({ ...prepare, time: this.chatList[0].time - 60 });
			    }
			    this.chatList.push(prepare);
			    this.scrollToBottom();
			    this.openChatSocket();
				this.socketLogin();
			    console.log(this.chatVid, JSON.parse(JSON.stringify(this.chatList)))
			  });
			},
			chatHandler(chat) {
				// customer 顾客
				// customer_service 客服
				// chat_intelligence 人工智能
				let time = chat.time || this.getNowTime();
				let type = ('type' in chat) ? chat.type : (('admin' in chat && chat.admin == '1') ? 'customer_service' : 'customer');
				let photo = type === 'customer' ? this.userPhoto : this.chatPhoto;
				let content = chat.text || '';
				let animate = true;
				return {
					...chat,
					type,
					time,
					photo,
					content,
					animate
				};
			},
			toggleContact() {
				if (this.$userInfo.data.name) {
				    return;
				}
				this.$contact().then(console.log);
			},
			toggleDisplay(show) {
				if (show) {
					this.isHidden = false;
					this.scrollToBottom();
				} else {
					this.isHidden = true;
				}
			},
			addNewMessage(chat) {
				this.chatList.push(this.chatHandler(chat));
				this.isHidden && (this.unreadLength += 1);
				this.scrollToBottom();
			},
			scrollToBottom() {
				this.timeout(500).then(() => {
					if (this.$refs['scroll-content']) {
					  const top = this.$refs['scroll-content'].offsetHeight,
							left = 0,
							behavior = 'smooth';
					  this.$refs['scroll-content'].parentNode.scrollTo({ top, left, behavior });
					}
				});
			},
			socketLogin() {
				console.log(this.account, this.pswd, this.uuid, this.name)
				this.chatSocket.emit('communication', {
					action: '/chat/login',
					data: {
						account: 'user',
						pswd: 'none',
						deviceUUID: this.uuid,
						name: this.name,
						admin: '0',
						use_type: 'chatArtificial'
					}
				});
			},
			openChatSocket() {
				if (this.chatSocket) {} else {
					this.chatSocket = socket({
						global: this,
						config: {
							debug: false,
					        connection: this.api.connection
						},
						events: {
							// socket连接失败
							'error'(error) {
								console.error('socket连接失败', error);
								// this.$message(error);
							},
							// socket正在连接
					        'connect'(data) {
					            console.log('连接', data)
					        	// this.chatSocket.emit('/chat/login', {
					        	// 	data: {
					        	// 		account: this.account,
					        	// 		pswd: this.pswd,
								// 		deviceUUID: this.uuid,
								// 		name: this.name
					        	// 	}
					        	// });
					        },
							
					        // socket连接成功
					        'socketConnectioned'(data) {
					            console.log('连接成功', data)
					        	// this.chatSocket.emit('communication', {
					        	// 	deviceUUID: this.uuid,
					        	// 	name: this.name,
					        	// 	account: 'user',
					        	// 	action: '/chat/login',
					        	// 	use_type: 'chatArtificial'
					        	// });
					        },
					        // 被管理员搭理
					        '/chat/beAcceptedChat'(data) {
								console.log('被管理员搭理', data)
					        	//this.adminUUID = data;// data.msgSource;
					        },
					        // 管理员下线了
					        '/chat/beLeftChat'(data) {
								console.log('管理员下线了', data)
					        	this.adminUUID = '';
					        },
					        // 接收聊天消息
					        '/chat/serverMsg'(data) {
								console.log('接收聊天消息', data)
					        	if (data.msgSource != 'myself') this.addNewMessage(data.data);
					        },
					        // 断开重连
					        'disconnect'(data) {
					            console.log('断开', data)
					            this.chatSocket.connect();
					        }
						}
					})
					;
				}
			},
			findPrepareAnswer(text) {
				text = text.toLowerCase();
				if (text) {
					const length = text.length;
					for (let { matter, answer } of prepareAnswer) {
						let matterList = Array.isArray(matter) ? matter : [ matter ];
						for (let item of matterList) {
							if (text.indexOf(item) > -1 && length - item.length < 3) {
								return typeof answer === 'function' ? answer() : answer;
							}
						}
					}
				}
				return '';
			}
		},
		filters: {
			timeParse(timestamp) {
				if (timestamp) {
					const time = new Date(timestamp * 1000);
					const weeHour = new Date().setHours(0, 0, 0, 0) / 1000;
					const [month, date, hour, minute] = [time.getMonth() + 1, time.getDate(), time.getHours(), time.getMinutes()].map(item => item < 10 ? ('0' + item) : item);
					return timestamp < weeHour ? (month + '-' + date) : (hour + ':' + minute);
				}
				return '';
			}
		},
		computed: {
			api() {
				// const baseURL = 'http://192.168.0.106:23334';
				// const baseURL = 'https://rtservice.xitohere.com';
				// const baseURL = process.env.NODE_ENV === 'development' ? 'http://192.168.0.106:23334' : 'http://rtservice.xitohere.com';
				const baseURL = 'https://rtservice.xitohere.com';
				const connection = baseURL + '?use_type=chatArtificial';
				const getChatMessagesList = baseURL + '/chat/getChatMessagesList';
				return {
					baseURL,
					connection,
					getChatMessagesList
				};
			},
			name() {
				return this.$userInfo.data.name || 'user';
			},
			className() {
				return 'type-talk-' + (this.isDisplay ? 'show' : 'hide');
			},
			isDisplay() {
				return this.isHidden === false;
			},
			userPhoto() {
				// https://webapp.xitohere.com/static/image/userHeadImg.png
				// https://webapp.xitohere.com/static/image/intelligence.png
				// https://gahaf.xitohere.com/Uploads/Picture/2019-10-22/5daec4bc9b4d4.png
				return require('../../../../assets/image/user.png');
			},
			chatPhoto() {
        		return this.showData && this.showData.logo || require('../../../../assets/image/logo.png');
			}
		},
		beforeDestroy() {
			this.chatSocket && this.chatSocket.close();
		}
	}
</script>

<style scoped>
	.type-talk{
		position: fixed;
		z-index: 111;
		border-radius: 4px;
		transition: all 300ms;
		background-color: transparent;
		/* box-shadow: 0px 0px 12px #909399; */
		filter: drop-shadow(0px 0px 12px #909399);
	}
	.type-talk-show{
		/* width: 500px; */
		/* height: 500px; */
	}
	.type-talk-hide{
		width: 40px;
		height: 40px;
	}
	.chat-show, .chat-hide, .unread-message::after, .chat-logo{
		width: 100%;
		height: 100%;
		border-radius: inherit;
	}
	.chat-show{
		overflow: hidden;
		background-color: #FFFFFF;
	}
	.chat-hide{
		cursor: pointer;
		position: relative;
	}
	.unread-message::before, .unread-message::after, .chat-close::before, .chat-close::after{
		position: absolute;
		top: 50%;
		left: 50%;
	}
	.unread-message::before{
		content: attr(data-number);
		z-index: 20;
		color: #FFFFFF;
		font-size: 12px;
		padding: 3px 9px;
		border-radius: 20px;
		background-color: #FF4949;
		transform: translate(-50%, -50%) scale(0.8);
	}
	.unread-message::after{
		content: '';
		z-index: 10;
		width: 100%;
		height: 100%;
		transform: translate(-50%, -50%);
		background-color: rgba(0, 0, 0, 0.15);
	}
	.unread-message:hover::before{
		animation: shake 820ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
	}
	.chat-content::-webkit-scrollbar, .chat-text::-webkit-scrollbar{
		/* width: 4px; */
		width: 0;
	}
	.chat-content::-webkit-scrollbar-thumb, .chat-text::-webkit-scrollbar-thumb{
		border-radius: 2px;
		background-color: #E4E7ED;
	}
	.chat-content::-webkit-scrollbar-track, .chat-text::-webkit-scrollbar-track{
		border-radius: 2px;
		background-color: #F2F6FC;
	}
	.chat-content::-webkit-scrollbar-thumb:hover, .chat-text::-webkit-scrollbar-thumb:hover{
		background-color: #909399;
	}
	.chat-header{
		width: 100%;
		height: 30px;
		display: flex;
		position: relative;
		align-items: center;
		justify-content: flex-end;
	}
	.message-text, .loading-text{
		position: absolute;
		left: 50%;
		color: #FFFFFF;
		font-size: 12px;
		padding: 6px 15px;
		border-radius: 3px;
		white-space: normal;
		background-color: #333333;
		box-shadow: 0 3px 10px #333333;
		transform: translate(-50%, -50%) scale(0.8);
	}
	.message-text{
		top: 30px;
		z-index: 1;
	}
	.loading-text{
		top: 60px;
		z-index: 2;
	}
	.chat-close{
		width: 20px;
		height: 20px;
		cursor: pointer;
		margin-right: 10px;
		position: relative;
	}
	.chat-close::before, .chat-close::after{
		content: '';
		width: 14px;
		height: 2px;
		background-color: #E4E7ED;
	}
	.chat-close::before{
		transform: translate(-50%, -50%) rotate(45deg);
	}
	.chat-close::after{
		transform: translate(-50%, -50%) rotate(135deg);
	}
	.chat-close:hover::before, .chat-close:hover::after{
		background-color: #C0C4CC;
	}
	.chat-content{
		margin: 0 auto;
		overflow-x: hidden;
		overflow-y: scroll;
		margin-bottom: 4px;
		width: calc(100% - 30px);
		height: calc(100% - 135px);
	}
	.chat-list{
		width: 100%;
	}
	.single-chat{
		width: 100%;
		display: flex;
		margin-bottom: 15px;
	}
	.chat-view{
		display: inline-flex;
		align-items: flex-start;
		max-width: calc(100% - 35px);
	}
	.chat-img{
		width: 30px;
		height: 30px;
		border-radius: 2px;
	}
	.name-time{
		display: flex;
		line-height: 1;
		margin-bottom: 5px;
		align-items: flex-end;
	}
	.chat-name{
		color: #000000;
		font-size: 14px;
	}
	.chat-time{
		color: #909399;
		font-size: 12px;
	}
	.text-view{
		padding: 5px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 3px;
		background-color: #EBEEF5;
	}
	.side-chat, .side-chat .chat-view, .side-chat .name-time{
		flex-direction: row;
	}
	.self-chat, .self-chat .chat-view, .self-chat .name-time{
		flex-direction: row-reverse;
	}
	.side-chat .chat-info, .side-chat .chat-time{
		margin-left: 5px;
	}
	.self-chat .chat-info, .self-chat .chat-time{
		margin-right: 5px;
	}
	.chat-footer{
		height: 70px;
		padding: 15px;
		display: flex;
		align-items: flex-start;
		width: calc(100% - 30px);
		border-top: 1px solid #E4E7ED;
		justify-content: space-between;
	}
	.chat-text{
		padding: 0;
		resize: none;
		height: 70px;
		font-size: 13px;
		line-height: 20px;
		box-sizing: border-box;
		width: calc(100% - 70px);
	}
	.chat-text, .chat-text::after, .chat-text:focus, .chat-button::after{
		border: none;
		outline: none;
	}
	.button-view{
		width: 60px;
	}
	.chat-button{
		width: 100%;
		height: 30px;
		border: none;
		outline: none;
		color: #FFFFFF;
		font-size: 13px;
		cursor: pointer;
		border-radius: 3px;
		background-color: #41466E;
	}
	.chat-button:hover, .chat-button:active{
		opacity: 0.8;
	}
	.fade-text-enter-active{
		animation: fade-text 300ms ease-in forwards;
	}
	.fade-text-leave-active{
		animation: fade-text 300ms ease-in forwards reverse;
	}
	@keyframes fade-text{
		from{
			opacity: 0.5;
			transform: translate(-50%, -100px) scale(0.6);
		}
		to{
			opacity: 1;
			transform: translate(-50%, -50%) scale(0.8);
		}
	}
	@keyframes shake{
		10%, 90%{
			transform: translate3d(calc(-50% - 1px), -50%, 0) scale(0.8);
		}
		20%, 80%{
			transform: translate3d(calc(-50% + 2px), -50%, 0) scale(0.8);
		}
		30%, 50%, 70%{
			transform: translate3d(calc(-50% - 4px), -50%, 0) scale(0.8);
		}
		40%, 60%{
			transform: translate3d(calc(-50% + 4px), -50%, 0) scale(0.8);
		}
	}
	@media screen and (min-width: 720px){
		.type-talk{
			right: 30px;
			bottom: 90px;
		}
		.type-talk-show{
			width: 450px;
			height: 480px;
		}
	}
	@media screen and (max-width: 719px){
		.type-talk{
			top: 10px;
			left: 50%;
			transform: translateX(-50%);
		}
		.type-talk-show{
			width: 90%;
			height: 320px;
		}
	}
</style>